import { competition } from './main';

export const trackEvent = (eventName, options = {}) => {
    eventName = `Snake ${competition} - ${eventName}`;
    // google analytics 
    dataLayer.push({ 'event': eventName });
    // kissmetrics
    _kmq.push(['record', eventName]);
    if (!!options.alias) {
        _kmq.push(['identify', options.alias])
    }
    // facebook
    fbq('trackCustom', eventName);
};